import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import MagnifyingGlassSourceSvg from '../../../assets/icons/app/MagnifyingGlassSource.svg?raw';

export const MagnifyingGlassSourceIcon = (props) => (
    <CustomSVG svg={MagnifyingGlassSourceSvg} preserveColors appIconSmall {...props} />
);
